import React, { useContext } from "react";
import Section from "./component/Section/Section";
import DefaultPage from "./component/DefaultPage/DefaultPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Currency from "./component/Currency/Currency.js";
import Client from "./component/Client/Client";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import Login from "./component/Login";
import Logout from "./component/Logout";
import Profile from "./component/Profile";
import Callback from "./component/Callback";
import PrivateRoute from "./component/PrivateRoute";
import ServiceTable from "./component/Table/ServiceTable/ServiceTable";
import { GlobalProvider } from "./providers/GlobalProvider";
import CostCenter from "./component/CostCenter/CostCenter";
import Transactions from "./component/Transactions/Transactions";
import ActiveCurrencies from "./component/ActiveCurrencies/ActiveCurrencies";
import { ActivatedCurrencyProvider } from "./providers/CurrencyProvider";
import Vendor from "./component/Vendor/Vendor";
import Accruals from "./component/Accruals/Accruals";
import GlobalContext from "./providers/GlobalProvider";
import "./App.css";
import Loading from "./component/Loading";
import MapperSelector from "./component/Mappers/MapperSelector";
import ProcessedTransactions from "./component/Processed Transactions/ProcessedTransactions";
import GlobalSettings from "./component/settings/GlobalSettings";
import TransactionLines from "./component/Transaction Lines/TransactionLines";
import CreditNotes from "./component/Credit Notes/credit-notes";

export default function App() {
  return (
    <AuthProvider>
      <Pages />
    </AuthProvider>
  );
}

function Pages() {
  const { user } = useAuth();

  if (!user) {
    // useNavigate("/login");
    // return ( <Redirect to="/login" /> );
    return (
      <Router>
        <Section>
          <Routes>
            <Route path="*" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/callback" element={<Callback />} />
          </Routes>
        </Section>
      </Router>
    );
  } else {
    return (
      <GlobalProvider>
        <ActivatedCurrencyProvider>
          <AuthorizedPages />
        </ActivatedCurrencyProvider>
      </GlobalProvider>
    );
  }
}

function AuthorizedPages() {
  const { loading } = useContext(GlobalContext);
  const { user } = useAuth();

  if (loading) {
    return (
      <Section>
        <Loading />
      </Section>
    );
  }

  console.log("Loading is done", user);

  return (
    <Router>
      <Section>
        <div className="container">
          <div className="current-user-box mt-5">{user.profile.name}</div>
          <div className="row justify-content-md-center">
            <div className="col-6">
              <MapperSelector />
            </div>
          </div>
        </div>
        <Routes>
          <Route path="/" element={<DefaultPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/callback" element={<Callback />} />
          <Route exact path="/" element={<PrivateRoute />} />
          <Route path="/profile" element={<Profile />} />
          {/* <Route element={<CurrencyProvider />}> */}
          <Route path="/active-currencies" element={<ActiveCurrencies />} />
          <Route path="/listClient" element={<Client />} />
          <Route path="/vendors-list" element={<Vendor />} />
          <Route path="/accruals-list" element={<Accruals />} />
          {/* </Route> */}
          <Route path="/listCurrency" element={<Currency />} />
          <Route path="/service-page" element={<ServiceTable />} />
          <Route path="/cost-center-1" element={<CostCenter kind="1" />} />
          <Route path="/cost-center-2" element={<CostCenter kind="2" />} />
          <Route path="/cost-center-3" element={<CostCenter kind="3" />} />
          <Route path="/transactions" element={<Transactions type="sal" />} />
          <Route path="/credit-notes" element={<CreditNotes />} />
          <Route
            path="/transactions"
            element={<Transactions type="vendor" />}
          />
          <Route
            path="/processed-transactions"
            element={<ProcessedTransactions />}
          />
          <Route
            path="/processed-transactions/:transId"
            element={<TransactionLines />}
          />
          <Route path="/global-settings" element={<GlobalSettings />} />
        </Routes>
      </Section>
    </Router>
  );
}
